import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { installDebugLog } from './platform/debugLog'
import { startSession } from './platform/session'
import { initPreferences } from './ui/prefs'
import { navigate } from './ui/router'
import { App } from './ui/App'
import './ui/global.css'

installDebugLog()
initPreferences()

// Al reabrir la app instalada (que siempre arranca en «/»), se vuelve a donde estabas.
const previous = startSession()
if (previous && previous.route !== '/' && window.location.hash === '') {
  navigate(previous.route)
}

const root = document.getElementById('root')
if (!root) throw new Error('No existe #root')
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
